<template>
    <div>
        <div class="tips" v-if="!isPdf">
            <el-alert v-for="e in $store.state.errors" :key="e.key" :title="e.message" type="error" :closable="false">
            </el-alert>
        </div>
        <div class="deptSurvey" v-loading="loading">
            <template v-if="sort == 'one' || isPdf">
                <h4>
                    （一）主要职能
                </h4>
                <div class="deptCon">
                    <reason type="textarea" rows="23" classname="qksm widest nullable" name="mainFunc"
                        v-model:value="qksm['mainFunc']" ref="mainFunc"></reason>
                </div>
            </template>
            <template v-if="sort == 'two' || isPdf">
                <h4>
                    （二）机构人员、车辆情况
                </h4>
                <p style="text-indent : 2em">
                    {{ zone == 'wenzhou' ? '温州市' : '' }}{{ divname }}系统下属财政拨款单位{{ T1.单位数 }}个,编制数总计{{ T1.总计 }}人，其中：
                    <template v-for="(item, idx) in T1.编制" :key="idx">
                        {{ item.name }}{{ item.value }}人{{ idx + 1 == T1.编制.length ? '。' : '、' }}
                    </template>现实有
                    <template v-for="(item, idx) in T1.人员" :key="idx">
                        {{ item.name }}{{ item.value }}人{{ idx + 1 == T1.编制.length ? '，' : '、' }}
                    </template>车辆{{ T1.车辆 }}辆（详见附表一）。
                </p>
            </template>
        </div>
    </div>
</template>
<script>
import reason from "@/components/reason.vue";
import { editQksm, getDivList } from "@/api/index.js";
import { getBdata } from "@/api/zone.js";

export default {
    name: "deptSurvey",
    components: {
        reason,
    },
    props: {
        qksmData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            loading: true,
            typeText: "",
            divname: "",
            qksm: {},
            sort: this.$route.query.sort,
            isPdf: Boolean,
            name: "deptSurvey",
            单位构成: [],
            T1: {},
            zone: ''
        };
    },
    watch: {
        qksmData: {
            deep: true,
            handler: function (newVal, oldV) {
                this.qksm = newVal;
            },
        },
        单位构成: {
            handler() {
                // this.check()
            },
            deep: true
        },
        $route() {
            this.sort = this.$route.query.sort;
        },
    },
    created() {
        if (this.$parent.isPdf) {
            this.loading = false;
            this.isPdf = true;
            this.divname = this.$store.state.divData.divname
            this.typeText = this.$store.state.divData.type == 0 ? "单位" : "部门";
            this.qksm = this.qksmData;
        } else {
            this.isPdf = false;
            this.getDivList();
        }
        this.单位构成 = this.qksm["单位构成"] ? JSON.parse(this.qksm["单位构成"]) : [];
        // this.addError();
        this.getDivData()
        // this.check()
    },
    updated: function () {
        if (!this.$parent.isPdf) {
            // this.addError();
        }
    },
    methods: {
        addError() {
            let str = "";
            if (
                this.isEmptyStr(this.qksm["mainFunc"]) &&
                this.qksm["mainFunc"] != "[未填]"
            ) {
                str += "主要职能";
            } else if (
                this.isEmptyStr(this.qksm["具体包括"]) &&
                this.qksm["具体包括"] != "[未填]"
            ) {
                str += "预算包括";
            }
            if (!this.isEmptyStr(str) && str.split(",").length > 0) {
                this.addOrSet("deptSurvey", str + "未填写完整");
            } else {
                this.remove("deptSurvey");
            }
        },
        async editQksm(qk, sm) {
            let form = {
                id: this.$route.query.divid,
                qk: qk,
                sm: sm,
            };
            let res = await editQksm(form);
            return res
        },
        async getDivList() {
            this.loading = true;
            let res = this.$store.state.divData;
            this.typeText = res.type == 0 ? "单位" : "部门";
            this.zone = res.zone;
            this.divname = res.divname;
            this.qksm = res.qksm;
            this.loading = false;
        },
        formatText(name) {
            var arr = this.qksm[name].split("\n");
            for (var i = 0; i < arr.length; i++) {
                var object = arr[i];
                arr[i] = object.replace(/^\s*/g, "") + "\n";
                arr[i] = "    " + arr[i];
            }
            if (name) {
                this.$refs[name].format = true;
                this.qksm[name] = arr.join("");
            }
        },
        async editPrevious(res) {
            if (res.主要职能) {
                this.qksm["mainFunc"] = res.主要职能;
                await this.editQksm("mainFunc", res.主要职能);
            }
            if (res.具体包括) {
                this.qksm["具体包括"] = res.具体包括;
                await this.editQksm("具体包括", 具体包括);
            }
            this.dialogVisible = false;
            this.$message.success('提取成功')
        },
        async editPrevious1(res) {
            this.qksm["mainFunc"] = res.主要职能;
            await this.editQksm("mainFunc", res.主要职能);
            this.qksm["具体包括"] = res.具体包括;
            await this.editQksm("具体包括", res.具体包括);
            this.$message.success('提取成功')
        },
        check: function () {
            if (this.单位构成.length == 0 || (this.单位构成.length > 0 && this.单位构成[0].name == "")) {
                this.addOrSet("unitsCom", "请检查本页：部门预算编制范围的二级预算单位未填。");
            } else {
                this.remove("unitsCom")
            }
        },
        appendRow() {
            this.单位构成.push({
                name: '',
            })
        },
        delect(index, num) {
            if (this.单位构成.length > 1) {
                this.单位构成.splice(index, num)
            } else {
                this.$alert('至少包含一个本级单位', '提示', {
                    confirmButtonText: '确定'
                })

            }
        },
        async save() {
            let res = await this.editQksm("单位构成", JSON.stringify(this.单位构成));
            if (res.status == 0) {
                this.$message.success("保存成功")
            }
        },
        async getDivData() {
            this.loading = true;
            let res = await getDivList({ id: this.$route.query.divid });
            if (res.status == 0) {
                this.divname = res.divname;
                this.qksm = res.qksm;
                this.tables = res.tables;
                this.typeText = res.type == 0 ? "单位" : "部门";
                let resBdata = await getBdata();
                if (resBdata.status == 0) {
                    resBdata.bdata.forEach((e) => {
                        if (e.name == 'T1') {
                            if (this.preview(e.expr).result) {
                                this.T1 = this.preview(e.expr).result;
                            } else {
                                this.errorType = true
                            }
                        }
                    });
                    if (this.errorType) {
                        this.$message.error('数据异常!')
                    } else {
                        this.isData = true;
                    }
                    this.loading = false
                }
            }
        },
        preview(expr) {
            try {
                let result = eval(this.makeEnvCode(this.tables) + expr);
                return {
                    result,
                };
            } catch (ex) {
                return {
                    ex,
                };
            }
        },
    },
};
</script>
<style scoped>
h4 .el-button {
    margin-left: 10px;
}

.deptSurvey h4 {
    font-size: 20px;
    line-height: 2.5em;
}

.deptSurvey p {
    line-height: 2.5em;
    font-family: FangSong;
    font-size: 20px;
}
</style>